<template>
  <div
    :class="{ 'bg-white': !isAuthenticated || hideSideBar }"
    class="flex flex-col full-height"
  >
    <sidebar
      v-if="isAuthenticated && !hideSideBar"
      v-model="sidebarCollapsed"
    />

    <div
      class="full-height main-content"
      :class="{
        'offset': !sidebarCollapsed && isAuthenticated && !hideSideBar,
        'sidebar-width': sidebarCollapsed && isAuthenticated && !hideSideBar,
      }"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  Sidebar,
} from '@/components';

export default {
  name: 'App',
  components: {
    Sidebar,
  },
  data() {
    return {
      sidebarCollapsed: false,
      hideSideBarPath: [
        '/reset-password-verification',
        '/temp-report',
      ],
    };
  },
  computed: {
    ...mapGetters('user', [
      'isAuthenticated',
    ]),
    hideSideBar() {
      return this.hideSideBarPath.some((path) => this.$route?.path.includes(path));
    },
  },
};
</script>

<style>
html, body {
  background-color: #fafafa;
  height: 100%;
}
</style>

<style lang="scss" scoped>
.main-content {
  transition: margin 0.3s ease;

  &.offset {
    margin-left: 220px;
  }
  &.sidebar-width {
    margin-left: 50px;
  }
}
</style>
